import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import FeedbackModal from './FeedbackModal';
import { usePageContext } from '../hooks/usePageContext';

const ReportProblemButton: React.FC = () => {
    const [showModal, setShowModal] = useState(false);
    const pageContext = usePageContext();

    return (
        <>
            <button
                onClick={() => setShowModal(true)}
                className="text-xs sm:text-sm px-2 py-1 sm:px-3 sm:py-1.5 
                   bg-primary-bg text-text-secondary border-2 border-yellow-400 
                   hover:bg-yellow-400/10 
                   rounded-md font-semibold transition-all duration-200 
                   flex items-center gap-1 sm:gap-2"
            >
                <MessageSquare size={14} className="sm:w-4 sm:h-4" />
                <span className="hidden sm:inline">Report a Problem</span>
                <span className="sm:hidden">Report</span>
            </button>

            {showModal && (
                <FeedbackModal
                    pageContext={pageContext}
                    onClose={() => setShowModal(false)}
                />
            )}
        </>
    );
};

export default ReportProblemButton;
